import { useSelector } from 'react-redux';
import { State } from 'src/redux/types';
import { monitoringUrlItem } from '../types';

export const useMonitoringUrlList = (): [
  monitoringUrlItem,
  boolean | undefined
] => {
  const { data, loading } = useSelector(
    (state: State) => state.monitoring.monitoringUrlList
  );

  return [data || [], loading];
};
